import { apiGet, apiPost } from '../../utilities/apiClient';
import { getSessionIds } from './_sessionIds';

export const fetchHealthSettings = (projectId: number | string) => async (_dispatch: any) => {
  const { accountId, cognitoId } = getSessionIds();
  if (!accountId || !cognitoId) return { success: false };
  try {
    const res = await apiGet(`/health/settings/${projectId}/${accountId}/${cognitoId}`);
    return res;
  } catch (err: any) {
    return { success: false, message: err?.message };
  }
};

export const saveHealthSettings = (
  projectId: number | string,
  settings: { enabled: boolean; types: string[] }
) => async (_dispatch: any) => {
  const { accountId, cognitoId } = getSessionIds();
  if (!accountId || !cognitoId) return { success: false };
  try {
    const res = await apiPost(`/health/settings/${projectId}/${accountId}/${cognitoId}`, settings);
    return res;
  } catch (err: any) {
    return { success: false, message: err?.message };
  }
};

export const syncHealthData = (
  projectId: number | string,
  readings: Record<string, Array<{ value: number; unit: string; startDate: string; endDate?: string }>>
) => async (_dispatch: any) => {
  const { accountId, cognitoId } = getSessionIds();
  if (!accountId || !cognitoId) return { success: false };
  try {
    const res = await apiPost(`/health/sync/${projectId}/${accountId}/${cognitoId}`, { readings });
    return res;
  } catch (err: any) {
    return { success: false, message: err?.message };
  }
};

export const fetchHealthData = (projectId: number | string) => async (_dispatch: any) => {
  const { accountId, cognitoId } = getSessionIds();
  if (!accountId || !cognitoId) return { success: false };
  try {
    const res = await apiGet(`/health/data/${projectId}/${accountId}/${cognitoId}`);
    return res;
  } catch (err: any) {
    return { success: false, message: err?.message };
  }
};

export const requestRemoteHealthSync = (projectId: number | string) => async (_dispatch: any) => {
  const { accountId, cognitoId } = getSessionIds();
  if (!accountId || !cognitoId) return { success: false };
  try {
    const res = await apiPost(`/health/request-sync/${projectId}/${accountId}/${cognitoId}`, {});
    return res;
  } catch (err: any) {
    return { success: false, message: err?.message };
  }
};

export const fetchRemoteHealthSyncStatus = (projectId: number | string) => async (_dispatch: any) => {
  const { accountId, cognitoId } = getSessionIds();
  if (!accountId || !cognitoId) return { success: false };
  try {
    const res = await apiGet(`/health/sync-status/${projectId}/${accountId}/${cognitoId}`);
    return res;
  } catch (err: any) {
    return { success: false, message: err?.message };
  }
};

export const generateHealthInsight = (
  projectId: number | string,
  recipientName?: string | null,
) => async (_dispatch: any) => {
  const { accountId, cognitoId } = getSessionIds();
  if (!accountId || !cognitoId) return { success: false };
  try {
    const res = await apiPost(`/health/generate-insight/${projectId}/${accountId}/${cognitoId}`, {
      recipient_name: recipientName ?? null,
    });
    return res;
  } catch (err: any) {
    return { success: false, message: err?.message };
  }
};

export const reportRemoteHealthSyncStatus = (
  projectId: number | string,
  report: { request_id: string; status: 'started' | 'completed' | 'failed'; error?: string },
) => async (_dispatch: any) => {
  const { accountId, cognitoId } = getSessionIds();
  if (!accountId || !cognitoId) return { success: false };
  try {
    const res = await apiPost(`/health/report-sync/${projectId}/${accountId}/${cognitoId}`, report);
    return res;
  } catch (err: any) {
    return { success: false, message: err?.message };
  }
};
